import call from './call';
import {SHOW_MSG} from "../types";
import languages from "../language/languages";
import getBase64File from "../helpers/getBase64File";

export default (form,file,onFinishCallBack) => async (dispatch,getState) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success) {
            if(onFinishCallBack)
                onFinishCallBack('webservices');
            dispatch({
                type: SHOW_MSG,
                payload: {message: languages[getState().auth.language].processOk, type: 'success'}
            });
        }
    }
    if(file)
        form.base64Cert = await getBase64File(file);
    else
        form.base64Cert =null;
    form.lastLogin=null;
    dispatch(call("UserService/updateWSUser",form,onResult));
};